import { GenericCrudPage } from "../../components/crud/GenericCrudPage.jsx";

export default function BlogCategoriesPage() {
  return (
    <GenericCrudPage
      config={{
        resource: "blog-categories",
        title: "Blog Categories",
        section: "Content",
        newLabel: "New category",
        defaultValues: { sortOrder: 0 },
        columns: [
          { key: "name", label: "Name", render: (r) => <strong>{r.name}</strong> },
          {
            key: "slug",
            label: "Slug",
            render: (r) => <span className="text-text-muted">{r.slug}</span>,
          },
          {
            key: "description",
            label: "Description",
            render: (r) => (
              <span className="text-text-secondary">
                {r.description ? r.description.slice(0, 80) : "—"}
              </span>
            ),
          },
        ],
        fields: [
          { name: "name", label: "Name", type: "text", required: true },
          { name: "slug", label: "Slug", type: "slug", source: "name" },
          { name: "description", label: "Description", type: "textarea", rows: 2 },
          { name: "sortOrder", label: "Sort order", type: "number" },
        ],
      }}
    />
  );
}
